import { ErrorLogger } from "@/utils/module_api";

let notifications_bootstrapped = false;

export async function bootNotifications(): Promise<void> {
  if (notifications_bootstrapped) return;
  notifications_bootstrapped = true;

  if (!("serviceWorker" in navigator)) {
    console.log("[bootstrap/notifications] no-op: serviceWorker unavailable");
    return;
  }

  const isDev = import.meta.env.DEV;
  const swUrl = isDev ? "/dev-sw.js?dev-sw" : "/sw.js";

  try {
    await navigator.serviceWorker.register(swUrl, { type: "module" });
    console.log("[bootstrap/notifications] service worker registered");
  } catch (err: any) {
    if (isDev) {
      console.log("[bootstrap/notifications] service worker registration deferred", err?.message);
      return;
    }
    ErrorLogger.logError(err as Error, "notifications_bootstrap");
    console.warn("[bootstrap/notifications] service worker registration failed", err);
  }
}
